var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBitcoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.154,
    height: 14.154,
    viewBox: "0 0 14.154 14.154",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bitcoin",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M14.154,7.077a7.077,7.077,0,0,1-12.081,5A7.077,7.077,0,0,1,12.081,2.073a7.031,7.031,0,0,1,2.073,5Z",
    transform: "translate(0)",
    fill: "#fee158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M263.077,7.077A7.077,7.077,0,0,1,256,14.154V0a7.077,7.077,0,0,1,7.077,7.077Z",
    transform: "translate(-248.923 0)",
    fill: "#ffb528"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 5.515,
    cy: 5.515,
    r: 5.515,
    transform: "translate(1.576 1.576)",
    fill: "#ffb528"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M261.584,59.584A5.591,5.591,0,0,1,256,65.168V54A5.591,5.591,0,0,1,261.584,59.584Z",
    transform: "translate(-248.923 -52.507)",
    fill: "#fe8c01"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M179.322,121.729a1.843,1.843,0,0,0-.3-.244,1.612,1.612,0,0,0-1.2-2.684h-.2V118h-.829v.8H174.96v.829h.677V124h-.677v.829h1.826v.8h.829v-.8h.424a1.815,1.815,0,0,0,1.283-3.1Zm-2.855-2.1h1.351a.783.783,0,0,1,.013,1.565h-1.364ZM178.039,124h-1.572v-1.974h1.572a.987.987,0,0,1,0,1.975Z",
    transform: "translate(-170.123 -114.738)",
    fill: "#fee158"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M258.655,123.012a1.819,1.819,0,0,1-1.816,1.816h-.424v.8H256V124h.838a.987.987,0,0,0,0-1.975H256v-.83h.63a.783.783,0,0,0-.013-1.565H256V118h.415v.8h.2a1.611,1.611,0,0,1,1.2,2.684,1.845,1.845,0,0,1,.3.244A1.8,1.8,0,0,1,258.655,123.012Z",
    transform: "translate(-248.923 -114.738)",
    fill: "#ffb528"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitcoin);
export default __webpack_public_path__ + "static/media/Bitcoin.4e3e9fe1036cdb0322c3932f4a180e06.svg";
export { ForwardRef as ReactComponent };